import { put, takeEvery } from 'redux-saga/effects';

import { AuthAction, StoreAction } from '../actions';
import { AuthConstant } from '../constants';
import history from '../history';

export default function* () {
  yield takeEvery(AuthConstant.CHANGE_PASSWORD_SUCCESS, changePasswordSuccess);
  yield takeEvery(AuthConstant.LOGIN_SUCCESS, loginSuccess);
  yield takeEvery(
    [AuthConstant.LOGOUT_ERROR, AuthConstant.LOGOUT_SUCCESS],
    logoutErrorOrSuccess,
  );
}

function* changePasswordSuccess(action) {
  yield put(AuthAction.setAuth(action?.payload));
}

function* loginSuccess(action) {
  yield put(AuthAction.setAuth(action?.payload));
  history?.push?.('/a/sale');
}

function* logoutErrorOrSuccess() {
  yield put(StoreAction.reset());
  history?.push?.('/login');
}
